export const STRATEGY_MINT_IDENTIFIER = "mint";
